function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient",
  x1: 243.57,
  y1: 353.49,
  x2: 243.57,
  y2: 303.2,
  gradientTransform: "matrix(-1 0 0 1 525.32 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d2dce6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e4e8f2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-2",
  x1: -1695.17,
  y1: 7944.57,
  x2: -1195.86,
  y2: 7944.57,
  gradientTransform: "matrix(1.33 -.51 -.72 -.86 7864.92 6286.32)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#f0f2f8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e4e8f2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-3",
  x1: 218.66,
  y1: 178.13,
  x2: 338.3,
  y2: 178.13,
  gradientTransform: "matrix(-1 0 0 1 520.73 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6e40aa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#503caa"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-4",
  x1: 227.58,
  y1: 483.64,
  x2: 227.58,
  y2: 445.28,
  gradientTransform: "matrix(-1 0 0 1 520.73 -292)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#78c864"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#adf37b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-5",
  x1: 241.57,
  y1: 456.58,
  x2: 241.57,
  y2: 418.23,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-6",
  x1: 241.57,
  y1: 510.8,
  x2: 241.57,
  y2: 472.44,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-7",
  x1: 257.53,
  y1: 483.64,
  x2: 257.53,
  y2: 445.28,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-8",
  x1: 271.52,
  y1: 510.8,
  x2: 271.52,
  y2: 472.44,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-9",
  x1: 271.52,
  y1: 456.58,
  x2: 271.52,
  y2: 418.23,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-10",
  x1: 287.47,
  y1: 483.64,
  x2: 287.47,
  y2: 445.28,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_5",
  x1: 135.07,
  y1: 161.17,
  x2: 135.07,
  y2: 3.59,
  gradientTransform: "matrix(-1 0 0 1 520.73 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#503caa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6e40aa"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_4",
  x1: 117.05,
  y1: 434.67,
  x2: 117.05,
  y2: 344.06,
  gradientTransform: "matrix(-1 0 0 1 520.73 -292)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#28a086"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-11",
  x1: 95.88,
  y1: 417,
  x2: 95.88,
  y2: 372.79,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-12",
  x1: 410.72,
  y1: 435.58,
  x2: 410.72,
  y2: 350.22,
  gradientTransform: "matrix(-1 0 0 1 520.73 -292)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#285ad2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#407de0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-13",
  x1: 405.72,
  y1: 416.92,
  x2: 405.72,
  y2: 378.78,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-14",
  x1: 374.06,
  y1: 416.92,
  x2: 374.06,
  y2: 378.78,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_2",
  x1: 130.14,
  y1: 569.6,
  x2: 130.14,
  y2: 485.56,
  gradientTransform: "matrix(-1 0 0 1 520.73 -292)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1ab4c2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1ac7c2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_3",
  x1: 111.08,
  y1: 551.95,
  x2: 111.08,
  y2: 519.1,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-15",
  x1: 406.29,
  y1: 569.43,
  x2: 406.29,
  y2: 485.6,
  xlinkHref: "#prevent-downtime_svg__New_Gradient_Swatch_2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_3-2",
  x1: 387.23,
  y1: 551.95,
  x2: 387.23,
  y2: 519.1,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_6",
  x1: 1054.68,
  y1: 868.84,
  x2: 1096.83,
  y2: 767.88,
  gradientTransform: "scale(-1 1) rotate(-31 -666.12 3347.692)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3a3f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#3d4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#454c5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#525b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#7e8fa7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#9cb1cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a3bad9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-16",
  x1: 1473.49,
  y1: -3.8,
  x2: 1496.61,
  y2: -3.8,
  gradientTransform: "matrix(-.92 -.4 -.4 .92 1793.24 878.12)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3a3f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3a3f4c",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-17",
  x1: 1423.51,
  y1: -18.57,
  x2: 1408.82,
  y2: -46.75,
  xlinkHref: "#prevent-downtime_svg__linear-gradient-16"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-18",
  x1: 1965.34,
  y1: -5464.13,
  x2: 1999,
  y2: -5464.13,
  gradientTransform: "matrix(-.96 .28 .28 .96 3934.99 4979.65)",
  xlinkHref: "#prevent-downtime_svg__linear-gradient-16"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-19",
  x1: 73.24,
  y1: 268.98,
  x2: 454.08,
  y2: 102.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#31353f",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31353f",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-20",
  x1: 91.17,
  y1: 328.34,
  x2: 472.35,
  y2: 328.34,
  xlinkHref: "#prevent-downtime_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-21",
  x1: 223.57,
  y1: 353.49,
  x2: 223.57,
  y2: 270.27,
  gradientTransform: "matrix(-1 0 0 1 525.32 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e4e9f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-22",
  x1: 175.37,
  y1: 328.33,
  x2: 390.59,
  y2: 328.33,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e8ecf2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cad3e0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__linear-gradient-23",
  x1: 406.3,
  y1: 249.82,
  x2: 95.01,
  y2: 454.28,
  xlinkHref: "#prevent-downtime_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_6-2",
  x1: 859.42,
  y1: 518.12,
  x2: 842.96,
  y2: 533.12,
  gradientTransform: "rotate(15.2 1473.084 -945.72)",
  xlinkHref: "#prevent-downtime_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prevent-downtime_svg__New_Gradient_Swatch_6-3",
  x1: 496.49,
  y1: 327.59,
  x2: 496.49,
  y2: 327.59,
  xlinkHref: "#prevent-downtime_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "prevent-downtime_svg__radial-gradient",
  cx: 458.75,
  cy: 284.29,
  r: 7.39,
  gradientTransform: "rotate(90 425.79 302.7)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "prevent-downtime_svg__radial-gradient-2",
  cx: 458.75,
  cy: 308.05,
  r: 7.39,
  xlinkHref: "#prevent-downtime_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "prevent-downtime_svg__radial-gradient-3",
  cx: 458.75,
  cy: 331.82,
  r: 7.39,
  xlinkHref: "#prevent-downtime_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("style", null, ".prevent-downtime_svg__cls-28,.prevent-downtime_svg__cls-29{fill:none}.prevent-downtime_svg__cls-5,.prevent-downtime_svg__cls-7{fill-rule:evenodd}.prevent-downtime_svg__cls-5{fill:#6e40aa}.prevent-downtime_svg__cls-7{fill:#adf37b}.prevent-downtime_svg__cls-47{fill:#23c386}.prevent-downtime_svg__cls-23{fill:#1ac7c2}.prevent-downtime_svg__cls-27,.prevent-downtime_svg__cls-50{opacity:.75}.prevent-downtime_svg__cls-28,.prevent-downtime_svg__cls-29{stroke:#3a3f4c;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px}.prevent-downtime_svg__cls-28,.prevent-downtime_svg__cls-50,.prevent-downtime_svg__cls-55{isolation:isolate}.prevent-downtime_svg__cls-32{fill:#3a3f4c}.prevent-downtime_svg__cls-35{fill:#fff}.prevent-downtime_svg__cls-50{fill:#748dad}.prevent-downtime_svg__cls-56{fill:#31353f}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "prevent-downtime_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M469.59 303.2H93.93c-1.55 0-2.76 2-2.76 4.39v41.51c0 2.46 1.26 4.39 2.76 4.39h375.66c1.55 0 2.76-2 2.76-4.39v-41.51c0-2.39-1.21-4.39-2.76-4.39z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.45 129.53C56 45.48 132.05 1 200.19 70.75c29 29.63 81 4.58 114.64-41.9 42.54-58.73 175.76-57.55 190.05 92 10 105.38-119.82 156.76-215.53 111.34-62.46-29.65-175.85 26.46-231.57-9.3-35.27-22.64-33.05-68.7-24.33-93.36z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("g", {
  id: "prevent-downtime_svg__Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "prevent-downtime_svg__Group-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M224.43 111.09v292.46m45.2-292.46v292.46m-227-292.46v292.46m45.2-292.46v292.46m46.3-292.46v292.46m45.2-292.46v292.46m124.09-213.56h-291m291 45.2h-291m291 92.6h-291m291 46.3h-291m291-92.6h-291m291-136.6h-291",
  stroke: "#111",
  strokeLinecap: "square",
  strokeOpacity: 0.05,
  strokeWidth: 1.13,
  fill: "none",
  id: "prevent-downtime_svg__Line-2"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M242.25 117.83H261v3a59.78 59.78 0 0141.08 56.83v.95A59.78 59.78 0 01261 235.43v3h-18.75a59.78 59.78 0 01-59.82-59.82v-.95a59.78 59.78 0 0159.82-59.83z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-3)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-5",
  d: "M260.85 117.83A59.79 59.79 0 00201 177.65v.95a59.82 59.82 0 10119.64 0v-.95a59.78 59.78 0 00-59.79-59.82z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.8 162.64h18.74v29H290.8a14.09 14.09 0 01-14.06-14.06v-1a14.12 14.12 0 0114.06-13.94z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-4)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M309.47 162.64a14.08 14.08 0 00-14.05 14.06v1a14.06 14.06 0 1028.11 0v-1a14.09 14.09 0 00-14.06-14.06z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.81 135.62h18.74v29h-18.74a14.08 14.08 0 01-14.05-14.05v-.95a14.06 14.06 0 0114.05-14z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-5)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M295.48 135.62a14.08 14.08 0 00-14.05 14v1a14.06 14.06 0 0028.11 0v-1a14.09 14.09 0 00-14.06-14z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.81 189.8h18.74v29h-18.74a14.08 14.08 0 01-14.05-14.06v-1a14.11 14.11 0 0114.05-13.94z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-6)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M294.53 189.8a14.08 14.08 0 00-14 14.06v.95a14.06 14.06 0 1028.11 0v-.95a14.09 14.09 0 00-14.11-14.06z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.85 162.64h18.74v29h-18.74a14.08 14.08 0 01-14.05-14.06v-1a14.11 14.11 0 0114.05-13.94z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-7)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M279.59 162.64a14.08 14.08 0 00-14 14.06v1a14.06 14.06 0 1028.11 0v-1a14.09 14.09 0 00-14.11-14.06z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.87 189.8h18.74v29h-18.74a14.09 14.09 0 01-14.06-14.06v-1a14.12 14.12 0 0114.06-13.94z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-8)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M264.66 189.8a14.09 14.09 0 00-14.06 14.06v.95a14.06 14.06 0 1028.11 0v-.95a14.13 14.13 0 00-14.05-14.06z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.87 135.62h18.74v29h-18.74a14.08 14.08 0 01-14.06-14.05v-.95a14.08 14.08 0 0114.06-14z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-9)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M265.54 135.62a14.08 14.08 0 00-14.06 14v1a14.06 14.06 0 0028.11 0v-1a14 14 0 00-14.05-14z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M231 162.64h18.67v29h-18.76a14.09 14.09 0 01-14.06-14.06v-1A14.18 14.18 0 01231 162.64z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-10)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M249.65 162.64a14.09 14.09 0 00-14.06 14.06v1a14.06 14.06 0 1028.12 0v-1a14 14 0 00-14.06-14.06z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M385.15 59.89h19.1v3.38a50.58 50.58 0 010 94.52v3.38h-19.1a50.64 50.64 0 110-101.28z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_5)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-5",
  d: "M404.66 59.89h-1a50.64 50.64 0 000 101.28h1a50.64 50.64 0 000-101.28z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M403.24 77.58h19.51v5.88a32.43 32.43 0 010 53.34v5.87h-19.58a32.55 32.55 0 11.07-65.09z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_4)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.75 77.58h-.94a32.55 32.55 0 100 65.09h.94a32.55 32.55 0 100-65.09z",
  transform: "translate(-28.01 7.3)",
  fill: "#23c386",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.51 96.22h18.64v28.83h-18.64a14 14 0 01-14-14v-.94a13.9 13.9 0 0114-13.89z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-11)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M441.15 96.22a14 14 0 00-14 14v1a14 14 0 1027.95 0v-1a14 14 0 00-13.95-14z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110 78.5h18.64v5.87a32.44 32.44 0 010 53.34v5.87H110a32.54 32.54 0 110-65.08z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-12)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100.53,
  cy: 118.27,
  r: 32.54,
  fill: "#407de0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.67 96.12h18.64V125h-18.64a14 14 0 01-14-14v-1a14 14 0 0114-13.88z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-13)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.34 96.12H163V125h-18.66a14 14 0 01-14-14v-1a14 14 0 0114-13.88z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-14)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M131.31 96.12a14 14 0 00-14 14v1a14 14 0 0028 0v-1a14 14 0 00-14-14zm31.69 0a14 14 0 00-14 14v1a14 14 0 0028-.12v-1a14 14 0 00-14-13.88z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.55 212.35l17.8.18.84 5.69a32.44 32.44 0 010 53.34l-1.35 6-17.29-.17a32.54 32.54 0 010-65.08z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_2)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  className: "prevent-downtime_svg__cls-23",
  cx: 379.31,
  cy: 252.36,
  r: 32.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.32 231.15H426V260h-18.68a14 14 0 01-14-14v-.95a14 14 0 0114-13.9z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_3)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M425.88 231.15a14 14 0 00-14 14v.94a14 14 0 1027.95 0v-.94a14 14 0 00-13.95-14z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.41 212.35H133v5.87a32.43 32.43 0 010 53.34v5.87h-18.59a32.54 32.54 0 110-65.08z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-15)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  className: "prevent-downtime_svg__cls-23",
  cx: 103.16,
  cy: 252.36,
  r: 32.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.17 231.15h18.63V260h-18.63a14 14 0 01-14-14v-.95a14 14 0 0114-13.9z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_3-2)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-7",
  d: "M149.73 231.15a14 14 0 00-14 14v.94a14 14 0 1028 0v-.94a14 14 0 00-14-14z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("g", {
  className: "prevent-downtime_svg__cls-27"
}, /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M130.36 110a12.23 12.23 0 0012.22-12.2V79.3a12.23 12.23 0 0112.22-12.22H296a12.22 12.22 0 0112.18 12.22v58.09A12.22 12.22 0 01296 149.61h-.41",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M163.71 110.53a12.22 12.22 0 0112.22 12.22v110.63a12.22 12.22 0 01-12.22 12.22H149.8",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-29",
  d: "M269.79 204.3h-80.55a13.31 13.31 0 00-13.31 13.31v5.84",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M310.9 177.53a12.64 12.64 0 0112.63 12.63v.84a12.62 12.62 0 0012.62 12.63h97.45",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M443.67 110.73a12.63 12.63 0 0112.63 12.63V191a12.63 12.63 0 01-12.63 12.63H426m-175.4-25.56h15a9.58 9.58 0 009.58-9.58v-9.3a9.58 9.58 0 00-9.58-9.58",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M425.88 246.72a12.63 12.63 0 0012.63-12.63v-17.18a13.31 13.31 0 00-13.31-13.31h-5.84",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-29",
  d: "M279.48 177.14h10.84a8.84 8.84 0 018.18 5.49l4.1 10a8.84 8.84 0 01-8.18 12.19",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M151.49 245.6a12.22 12.22 0 0112.22 12.22v70.52m-32.4-218.21h3.77a8.45 8.45 0 018.45 8.45v34.14a8.45 8.45 0 008.45 8.45h103.28a8.45 8.45 0 018.45 8.45 8.46 8.46 0 01-8.45 8.45h-4.66",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-29",
  d: "M443.93 110.73a12.37 12.37 0 0012.37-12.36v-41.2a12.37 12.37 0 00-12.37-12.37H320.54a12.37 12.37 0 00-12.36 12.37v27",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M163.71 268.68a8.45 8.45 0 008.45 8.45H426a12.56 12.56 0 0012.56-12.56v-5.29A12.56 12.56 0 00426 246.72",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-28",
  d: "M330.76 316.11V123.87A12.22 12.22 0 01343 111.65m10.08 216.69v-70.55a12.22 12.22 0 0112.22-12.22",
  transform: "translate(-28.01 7.3)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M428.67 270.55c.13-.06.5.1.52.32a32.6 32.6 0 0013.22 8.27 19.37 19.37 0 013.75 1.68 6.34 6.34 0 011.81 2.39c4.09-3.27 9.71-4.27 16.67-2.76l1.46.4c7 1.42 11.6 4.66 14 9.16a5.05 5.05 0 012.55-1.43 17.54 17.54 0 014 0 30.37 30.37 0 0015.32-2.13 1.63 1.63 0 01.67 0 1 1 0 01.76 1.29l-.19.46c-.2.46-1.28 1.75-1.51 2.3-1.27 1.74-5.15 5.54-6.78 10.71a4.92 4.92 0 00-.56 1.6l-3.06-.2 1.94 2.34a12.06 12.06 0 01-4.66 4.66l-3-2.45.58 3.28a11.33 11.33 0 01-6.1-.72 8.62 8.62 0 01-.53 3.57 6.82 6.82 0 01-3.5 4c-2.34 1.18-5.55 1.57-10.09 1.29a3.5 3.5 0 00-2.12 1.17c-.56 1.07-3 1.23-6.84.27h-.09a15.58 15.58 0 01-5-1.77 2.07 2.07 0 01-1.13-1.45 2.52 2.52 0 00-1.38-1.88c-4.37-1.73-7.37-3.64-9-5.64a6.09 6.09 0 01-1.1-5.13v-.09a9.76 9.76 0 011.07-2.8 10.81 10.81 0 01-2.45-.38l1.15-3-2.7 2.12.11-1.8-1.58 1.18a10.27 10.27 0 01-3.62-4.55l4.07-2.2-4.7.09a14.05 14.05 0 01-.47-4.32l2.13-.41-2.25-.84 3.17-.83-3.18-.69c0-4.75-1.67-8.94-2-10.94a18.61 18.61 0 00-.49-2.7c-.05-.13 0-.31 0-.54a1 1 0 011.13-.9z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437.52 282c3.58 2.59 6.51 4.91 6.61 7.77.24 3-1.75 6.75-3.24 10l-.46 1.1c-.86 0-1.67-.15-2.4-.24l1.15-3-2.81 2.37.11-1.8-1.58 1.18a10.27 10.27 0 01-3.62-4.55l4.07-2.2-4.7.09a13.78 13.78 0 01-.46-4.32l2.12-.41-2.25-.84 3.17-.83-3.18-.69c0-4.75-1.67-8.94-2-10.94a17.15 17.15 0 00-.5-2.7c2.55 5.01 6.22 7.61 9.97 10.01z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-16)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-32",
  d: "M462.69 283.54a7.26 7.26 0 00-3.18-.69c-.63 0-1.1.3-.9.6a3.85 3.85 0 002.62 1c1.35.13 1.77-.45 1.46-.91zm-2.35 1.72c-1.5-.3-.89 1.36-.16 1.67s2.21.17 2.09-.31c.18-.69-1.11-1.23-1.93-1.36zm6.98-.86a2.73 2.73 0 00-2.67.94c-.32.51.47 1 2.16 1.56s3.6.21 3.71-.29c-.09-.58-2.29-2.05-3.2-2.21z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480.84 297.67c.89-1.36 2.19-3.42 7.16-4.15h.1a24.48 24.48 0 006.11-1.12 33.43 33.43 0 009.1-4.63c-.19.46-1.27 1.74-1.5 2.29-1.28 1.75-5.15 5.54-6.78 10.71a4.84 4.84 0 00-.57 1.61l-3.06-.2 2 2.33a12.09 12.09 0 01-4.67 4.66l-3-2.45.58 3.28a10.9 10.9 0 01-6.1-.72 2 2 0 00-.16-1.15c-.58-3.33-.76-8.07.79-10.46z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-17)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447 301.88c-.16 1.67.77 2.82 3.68 3.39a4.79 4.79 0 011.09.24c3.3.41 4.73.36 8.27 1s4.89 1.51 8.09 2.42c.5.1.74.31 1.05.33 2.91.57 4.35 0 4.73-1.7 2 2.47-1.7 4.82-4.35 5.44a24.06 24.06 0 01-10.31 0l-1-.29a24 24 0 01-9.49-4c-2.09-1.75-4.7-5.34-1.8-6.83z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-18)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-35",
  d: "M471.66 311.5c1-.47 2.16-1.26 2.26-2.53h-.09v.09a2.91 2.91 0 01-2.67.94v.09l.58 1.44zm-1.96.8a9.13 9.13 0 001.4-.5v-.09l-.68-1.48h-.09l-.72 2a.1.1 0 00.05.13zm-.78-.22l.8-2.16c0-.09-.05-.13-.1-.26l-.5-.1a6.24 6.24 0 01-1.15-.37h-.09c-.09 0-.13.05-.26.11a.1.1 0 00.05.13l1.25 2.69zm-4.11.77a8.12 8.12 0 003.12-.21c.13-.05.26-.11.19-.46l-1.32-3.05h-.09l-2 3.18c0 .32 0 .54.09.58zm-.96-.3l2.19-3.41c0-.1 0-.32-.07-.36h-.09l-1.05-.33c-.65-.27-1.33-.45-2-.72-.09 0-.13.05-.26.1a.11.11 0 00.05.14l1.21 4.62zm-3.92-.23a12.78 12.78 0 002.8.31c.13-.06.35-.07.3-.2v-.1l-1.14-3.73m-.11-.26l-2.14 3.55c0 .09 0 .31.07.35h.09zm-2.92 3.42c0 .09.06.13 0 0l2.43-4c0-.09 0-.32-.07-.35h-.09a3.47 3.47 0 00-1.18-.28l-1.19-.28c-.09 0-.35.06-.3.2v.09l.44 4.63zm-3.66-.56c.73.31 1.73.51 2.69.8.1 0 .32 0 .3-.2v-.09l-.45-4.09h-.09l-2.48 3.08c-.17.14-.12.27 0 .54zm-.81-.67l3-3.61a.36.36 0 000-.31h-.09a9.51 9.51 0 00-2.08-.22h-1.21c-.09 0-.13.06-.26.11l.58 4zm-3.95-1.44a29.32 29.32 0 002.69 1.35c.09 0 .31 0 .35-.07v-.1l-.51-3.68-2.41 2.13c-.23 0-.17.15-.16.37zm-.61-3.19l-.08 2.25h.09l2-1.88a.39.39 0 000-.32h-.18a5.45 5.45 0 01-1.1-.25l-.5-.1c0 .09-.11.28-.24.33zm-1.77 1.1c.2.31.72.63 1.06 1.1.09 0 .09 0 .13-.05l.13-2.12h-.09l-1.23 1.07c-.05-.13-.27-.11 0 0zm-.92-1.14a1.43 1.43 0 00.43.5m0 .1l1.1-1.06v-.09a4 4 0 01-1.55-1c-.19-.3-.62-.58-.65-1h-.09a1.26 1.26 0 00-.1.5 2.89 2.89 0 00.91 2.23z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-32",
  d: "M477.12 297.74c-2.33-.66-5.77 1.59-10.74 2.32-1.73.25-3.64.42-3.87.43a12.82 12.82 0 002.66.9 5 5 0 004.23 3.61 4.9 4.9 0 006-2.9c.14-.59.34-1.05.48-1.65a15.83 15.83 0 00-4.34-.52 12.89 12.89 0 015.06-.69 11 11 0 012.35.88s-.1-2.1-1.46-2.46zm-29.96-4.35a11.22 11.22 0 014.4 2.72 13.94 13.94 0 00-4.35-1.28 5.32 5.32 0 00-.19 1.76 4.74 4.74 0 004.31 5 5.2 5.2 0 005.36-1.66 12.58 12.58 0 002.71.27 23.64 23.64 0 01-3.5-2c-4.16-2.73-6.58-6-8.8-6.41-1.5-.3-2.35 1.72-2.35 1.72a3.84 3.84 0 012.41-.07z",
  transform: "translate(-28.01 7.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.37 296a14.16 14.16 0 00-4.34-1.28 5.6 5.6 0 00-.2 1.76 4.75 4.75 0 004.32 5 5.16 5.16 0 005.36-1.66 69.785 69.785 0 01-5.14-3.78zm13.72 5.58a5.43 5.43 0 004.23 3.62 4.91 4.91 0 005.9-2.95c.14-.59.34-1.05.48-1.64a15.45 15.45 0 00-4.34-.52 37 37 0 01-6.27 1.49z",
  transform: "translate(-28.01 7.3)",
  fill: "#3eb883"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.86 302.54c.07-1 5.13-1.1 5.13-1.1 1.64-.29 1.3.76.83 1.11s-1.74 2.08-3.1 1.95a3.54 3.54 0 01-2.86-1.96zm-18.21-4.94a4.31 4.31 0 002.31 3c1.38.58 3.06.2 3.5-.59s-4.24-3.08-4.24-3.08c-.88-.45-1.97-.69-1.57.67z",
  transform: "translate(-28.01 7.3)",
  fill: "#8fe6c1"
}), /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-35",
  d: "M469 301.81s-1.69.16-2 .8 2.4-.29 3.1-.42.2-.47-1.14-.38zm-16.26-3.36s1.53.75 1.35 1.43-2.19-1.24-2.72-1.79c-.46-.19.12-.28 1.37.36z",
  transform: "translate(-28.01 7.3)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M483.71 350.51H101c-1.55 0-2.76 2-2.76 4.39v-.83c0 2.47 1.26 4.39 2.76 4.39h382.71c1.54 0 2.75-2 2.75-4.39v.83c0-2.38-1.21-4.39-2.75-4.39z",
  transform: "translate(-28.01 7.3)",
  fill: "#748dad"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 80.91,
  y: 31.2,
  width: 375.05,
  height: 304.44,
  rx: 13.36,
  fill: "url(#prevent-downtime_svg__linear-gradient-19)",
  opacity: 0.3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M98.92 37.26V315a13.36 13.36 0 0013.36 13.36h10A13.36 13.36 0 01108.92 315V37.26a13.36 13.36 0 0113.36-13.36h-10a13.36 13.36 0 00-13.36 13.36z",
  transform: "translate(-28.01 7.3)",
  fill: "#31353f",
  opacity: 0.3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M484 37.26V315a13.36 13.36 0 01-13.36 13.36h-10A13.36 13.36 0 00474 315V37.26a13.36 13.36 0 00-13.33-13.36h10A13.36 13.36 0 01484 37.26z",
  transform: "translate(-28.01 7.3)",
  opacity: 0.05,
  fill: "#31353f"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M469.59 303.2H93.93c-1.55 0-2.76 2-2.76 4.39v41.51c0 2.46 1.26 4.39 2.76 4.39h375.66c1.55 0 2.76-2 2.76-4.39v-41.51c0-2.39-1.21-4.39-2.76-4.39z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-20)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M489.59 303.2H113.93c-1.55 0-2.76 2-2.76 4.39v41.51c0 2.46 1.26 4.39 2.76 4.39h375.66c1.55 0 2.76-2 2.76-4.39v-41.51c0-2.39-1.21-4.39-2.76-4.39z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-21)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 444.16,
  cy: 335.64,
  r: 7.4,
  fill: "url(#prevent-downtime_svg__radial-gradient)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "prevent-downtime_svg__cls-47",
  cx: 444.16,
  cy: 335.64,
  r: 4.3
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 420.39,
  cy: 335.64,
  r: 7.4,
  fill: "url(#prevent-downtime_svg__radial-gradient-2)"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "prevent-downtime_svg__cls-47",
  cx: 420.39,
  cy: 335.64,
  r: 4.3
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 396.63,
  cy: 335.64,
  r: 7.4,
  fill: "url(#prevent-downtime_svg__radial-gradient-3)"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "prevent-downtime_svg__cls-47",
  cx: 396.63,
  cy: 335.64,
  r: 4.3
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-50",
  d: "M400.89 335.44H178.76a3.33 3.33 0 01-3.3-3.3v-7.6a3.33 3.33 0 013.3-3.3h222.13a3.33 3.33 0 013.3 3.3V332a3.35 3.35 0 01-3.3 3.44z",
  transform: "translate(-28.01 7.3)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M389.05 335.43H178.57a3.16 3.16 0 01-3.2-3.2v-5c8.37 0 11.33 5.3 23.47 3.55s14.28 2.32 30.39 2.32c10.29 0 17.11-4.28 26.74-4.28 14 0 12.87 4.23 29.51 4.23 17.09 0 21.1 1 38.26-.4 9.11-.74 11.91-4.3 16.56-4.3 10.73 0 10.7 7 47.85 7a3.23 3.23 0 01.9.08z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__linear-gradient-23)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-50",
  d: "M104.88 335.24v-10.66a1.1 1.1 0 000-.18c0-2.7-1.61-4.9-3.6-4.9s-3.6 2.2-3.6 4.9v11.19c0 2.71 1.61 4.9 3.6 4.9s3.6-2.19 3.6-4.9v-.35z",
  transform: "translate(-28.01 7.3)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M488.51 318.52a.68.68 0 01-.47.15.7.7 0 01-.8-.66 8.76 8.76 0 011.42-4.76 8.36 8.36 0 00-4.6-.34.52.52 0 01-.44 0 .62.62 0 01-.33-.8 9 9 0 014.47-4.12 9.83 9.83 0 00-3.88-.84.27.27 0 01-.4-.12.78.78 0 010-1c2.08-2.24 6.38-5.54 10.58-3.33s2.7 10.3-.24 11.82a23.55 23.55 0 00-5.31 4z",
  transform: "translate(-28.01 7.3)",
  fill: "url(#prevent-downtime_svg__New_Gradient_Swatch_6-2)"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  className: "prevent-downtime_svg__cls-27"
}, /*#__PURE__*/React.createElement("g", {
  className: "prevent-downtime_svg__cls-55"
}, /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-56",
  d: "M101.3 329.44H89.39a11.72 11.72 0 01-11.71-11.71v-59.94a14.73 14.73 0 0114.72-14.72 2.5 2.5 0 110 5 9.73 9.73 0 00-9.72 9.72v59.94a6.72 6.72 0 006.71 6.71h11.91c1.38 0 1.38 5 0 5z",
  transform: "translate(-28.01 7.3)"
})), /*#__PURE__*/React.createElement("g", {
  className: "prevent-downtime_svg__cls-55"
}, /*#__PURE__*/React.createElement("path", {
  className: "prevent-downtime_svg__cls-56",
  d: "M101.3 335.46H89.18a17.63 17.63 0 01-17.61-17.61V123.26a14.73 14.73 0 0114.72-14.72 2.5 2.5 0 010 5 9.73 9.73 0 00-9.72 9.72v194.59a12.62 12.62 0 0012.61 12.61h12.12c1.38 0 1.38 5 0 5z",
  transform: "translate(-28.01 7.3)"
})));

function SvgPreventDowntime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 481.27 404.11"
  }, props), _ref, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "prevent-downtime_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("image", {
    width: 433,
    height: 52,
    transform: "translate(48.27 332.19)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67
  }), _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, /*#__PURE__*/React.createElement("path", {
    d: "M390.59 324.43v7.8a3.22 3.22 0 01-2.44 3.1 2.73 2.73 0 01-.76.1H178.57a3.16 3.16 0 01-3.2-3.2v-7.8a3.16 3.16 0 013.2-3.2h208.82a3.16 3.16 0 013.2 3.2z",
    transform: "translate(-28.01 7.3)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.8,
    fill: "url(#prevent-downtime_svg__linear-gradient-22)"
  }), _ref16, _ref17, _ref18, _ref19, /*#__PURE__*/React.createElement("path", {
    id: "prevent-downtime_svg__path10351",
    d: "M158 331.73s-.09 0-.09-.05-.1-.05-.2-.05a2.28 2.28 0 00-.58-.05.78.78 0 01-.3 0h-.05a9.55 9.55 0 01-1.65-.3.59.59 0 01-.35-.34l-.39-.1a12.66 12.66 0 00-.19-4.29 13.25 13.25 0 00-1.71-4l.29-.29v-.05a.67.67 0 01.15-.44 8.52 8.52 0 011.37-1l.29-.15c.19-.1.34-.2.54-.29 0-.05.09-.05.14-.1s0-.05 0-.1a1 1 0 00.2-1.36.93.93 0 00-.69-.35 1.16 1.16 0 00-.68.25c-.05.05-.09.09-.14.09a3 3 0 00-.39.44c-.05.1-.15.15-.2.2a6.25 6.25 0 01-1.22 1.07.67.67 0 01-.29.1.3.3 0 01-.2-.05l-.39.24c-.39-.39-.82-.78-1.21-1.17a12.52 12.52 0 00-6.35-2.53v-.39.05a.7.7 0 01-.25-.39 9.48 9.48 0 01.1-1.66c0-.1.05-.2.05-.29s.05-.39.1-.59v-.29a1 1 0 00-.83-1 1.1 1.1 0 00-1.13 1v.24a2.43 2.43 0 00.1.59.58.58 0 010 .29v.05a8.93 8.93 0 01.1 1.66.7.7 0 01-.25.39v.48c-.54.05-1.08.15-1.66.25a11.66 11.66 0 00-6 3.41l-.3-.19h-.2a.67.67 0 01-.29-.1 8.77 8.77 0 01-1.22-1.12c0-.1-.15-.15-.2-.2s-.24-.29-.39-.44-.09-.05-.14-.09v-.05a1.17 1.17 0 00-.69-.25.75.75 0 00-.68.34 1.06 1.06 0 00.2 1.37l.05.05s.09.1.14.1l.54.29.29.15a6.76 6.76 0 011.37 1 .51.51 0 01.14.44v-.05l.3.29c-.05.1-.1.15-.15.25a11.59 11.59 0 00-1.71 8l-.39.1h-.05a.76.76 0 01-.34.35 9.58 9.58 0 01-1.66.29.61.61 0 00-.29.05c-.19 0-.39.05-.58.05a1.37 1.37 0 01-.2 0c-.05 0-.05 0-.1.05a1 1 0 00-.78 1.13.92.92 0 001 .68.42.42 0 00.24-.05c.05 0 .05 0 .05-.05s.15 0 .2 0 .39-.15.53-.19a.71.71 0 01.3-.1 8.7 8.7 0 011.61-.44h.05a.53.53 0 01.39.15h.49a11.76 11.76 0 004 5.7 7.58 7.58 0 001.32.88l-.25.34.05.05a.57.57 0 010 .49 7.77 7.77 0 01-.78 1.41v.05a1 1 0 01-.19.25c-.1.09-.2.29-.35.48s0 .1-.09.15v.05a1 1 0 00.39 1.32 1.07 1.07 0 00.34.09 1.1 1.1 0 00.93-.58v-.05s.05-.1.1-.15.15-.34.2-.53l.1-.3a8.31 8.31 0 01.63-1.51.74.74 0 01.39-.29c.05 0 .05 0 .05-.05l.19-.39a11.44 11.44 0 004.25.78 9.89 9.89 0 002.63-.34 14.2 14.2 0 001.56-.44l.2.34v.05a.84.84 0 01.39.29 9.08 9.08 0 01.63 1.51v.05l.1.3a1.94 1.94 0 00.19.53c.05.05.05.1.1.15l.05.05a1.09 1.09 0 00.93.58 1.46 1.46 0 00.39-.09.86.86 0 00.44-.54 1.4 1.4 0 000-.73l-.05-.05c0-.05-.05-.1-.1-.15a1.87 1.87 0 00-.34-.49 1 1 0 00-.2-.24v-.1a5.93 5.93 0 01-.78-1.41.57.57 0 010-.49l.05-.05-.15-.39a12 12 0 005.27-6.63h.44a.56.56 0 01.39-.15h.01a8.76 8.76 0 011.56.44.72.72 0 00.29.1 2.55 2.55 0 00.54.24h.19c.09 0 0 0 .1.05a.45.45 0 00.25.05 1 1 0 001-.68 1.16 1.16 0 00-.88-1zm-14.09-1.51l-1.32.63-1.32-.63-.27-1.42.93-1.17h1.46l.93 1.17zm7.95-3.17a9.36 9.36 0 01.19 3.07l-4.63-1.32a.8.8 0 01-.59-1 .72.72 0 01.2-.34l3.66-3.32a10.26 10.26 0 011.2 2.91zm-2.64-4.68l-4 2.82a.82.82 0 01-1.07-.19.45.45 0 01-.15-.34l-.29-4.93a9.1 9.1 0 015.51 2.64zm-8.83-2.49l1-.2-.24 4.88a.81.81 0 01-.83.78 1.07 1.07 0 01-.39-.1l-4.05-2.87a9.71 9.71 0 014.54-2.49zm-5.95 4.29l3.61 3.22a.79.79 0 01.1 1.12.54.54 0 01-.39.25l-4.73 1.36a10.25 10.25 0 011.44-5.95zm-.83 8.24l4.83-.83a.81.81 0 01.83.64.57.57 0 01-.05.49l-1.85 4.48a9.62 9.62 0 01-3.73-4.78zm11.08 6a9.73 9.73 0 01-2.1.25 11 11 0 01-3.07-.49l2.39-4.34a.75.75 0 011-.2 2.44 2.44 0 01.39.34l2.34 4.25a7.56 7.56 0 00-.92.24zm5.95-4.24a9.42 9.42 0 01-2.93 2.93l-1.9-4.59a.8.8 0 01.44-.93 1.33 1.33 0 01.44-.09l4.87.82a7.18 7.18 0 01-.89 1.91z",
    transform: "translate(-28.01 7.3)",
    style: {
      isolation: "isolate"
    },
    fill: "#31353f",
    opacity: 0.75
  })));
}

export default __webpack_public_path__ + "static/prevent-downtime.bcf6d9c5.svg";
export { SvgPreventDowntime as ReactComponent };